var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 63,
    viewBox: "0 0 42 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 0C9.19999 0 0 9.19995 0 20.5099C0 30.1799 5.64 35.15 8.66 37.81C9.01 38.12 9.33001 38.4 9.60001 38.65C10.9 39.87 11.12 41.13 11.13 42.37L10.83 45.94H30.19L29.89 42.37C29.89 41.13 30.12 39.87 31.41 38.65C31.68 38.39 32 38.11 32.35 37.81C35.38 35.15 41.01 30.1799 41.01 20.5099C41.02 9.19995 31.82 0 20.51 0Z",
    fill: "#7681FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5094 62.4637C26.3894 62.4637 31.1494 57.7238 31.1494 51.8738V41.0938H9.85938V51.8738C9.86937 57.7238 14.6294 62.4637 20.5094 62.4637Z",
    fill: "#525ab0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0897 47.0187H8.9397C7.8297 47.0187 6.92969 46.1187 6.92969 45.0087V42.4788C6.92969 41.3688 7.8297 40.4688 8.9397 40.4688H32.0897C33.1997 40.4688 34.0997 41.3688 34.0997 42.4788V45.0087C34.0997 46.1187 33.1997 47.0187 32.0897 47.0187Z",
    fill: "#525ab0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0897 53.5734H8.9397C7.8297 53.5734 6.92969 52.6735 6.92969 51.5635V49.0334C6.92969 47.9234 7.8297 47.0234 8.9397 47.0234H32.0897C33.1997 47.0234 34.0997 47.9234 34.0997 49.0334V51.5635C34.0997 52.6735 33.1997 53.5734 32.0897 53.5734Z",
    fill: "#525ab0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4025 13.8438H25.4125L22.9625 20.4738H27.5225L15.3125 32.9037L18.8925 22.5837H15.3125L18.4025 13.8438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIconBig);
export default __webpack_public_path__ + "static/media/sadIconBig.3a066fa022fab715b78676f49d4dd799.svg";
export { ForwardRef as ReactComponent };